import { createAction, props } from '@ngrx/store';

import { SelectOption } from 'src/app/_ui/components/form/common';

export const PrtgHostsTypesListLoaded = createAction(
    '[PRTG-VALUES] Prtg Hosts Types List Loaded',
    props<{ hostsTypes: SelectOption[] }>()
);
export const PrtgHostsStatusesListLoaded = createAction(
    '[PRTG-VALUES] Prtg Hosts Statuses List Loaded',
    props<{ hostsStatuses: SelectOption[] }>()
);
export const PrtgHostsPaginationLoaded = createAction(
    '[PRTG-VALUES] Prtg Hosts Pagination Loaded',
    props<{ total: number; pages: number; currentPage: number; limit: number }>()
);
export const PrtgServicesTypesListLoaded = createAction(
    '[PRTG-VALUES] Prtg Services Types List Loaded',
    props<{ servicesTypes: SelectOption[] }>()
);
export const PrtgServicesStatusesListLoaded = createAction(
    '[PRTG-VALUES] Prtg Services Statuses List Loaded',
    props<{ servicesStatuses: SelectOption[] }>()
);
export const PrtgServicesPaginationLoaded = createAction(
    '[PRTG-VALUES] Prtg Services Pagination Loaded',
    props<{ total: number; pages: number; currentPage: number; limit: number }>()
);

export const PrtgServicesDetailPaginationSet = createAction(
    '[PRTG-VALUES] Prtg Services Detail Pagination Set',
    props<{ page: number; limit: number }>()
);
